var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00566 1.7207H15.4275C15.5488 1.72074 15.6674 1.75604 15.7689 1.82229C15.8704 1.88854 15.9505 1.98289 15.9993 2.09385C16.0482 2.2048 16.0637 2.32757 16.044 2.44719C16.0244 2.56681 15.9703 2.67813 15.8885 2.76758L10.7557 8.41601C10.6488 8.53036 10.5901 8.68142 10.5916 8.83789V13.2598C10.5926 13.3636 10.5673 13.4661 10.5181 13.5576C10.469 13.6491 10.3975 13.7267 10.3103 13.7832L7.81035 15.4473C7.71657 15.509 7.60788 15.5444 7.49571 15.5496C7.38355 15.5549 7.27204 15.5298 7.17291 15.477C7.07379 15.4243 6.99071 15.3458 6.93241 15.2498C6.8741 15.1538 6.84274 15.0439 6.8416 14.9316V8.83789C6.84311 8.68142 6.78436 8.53036 6.67754 8.41601L1.54472 2.76758C1.46289 2.67813 1.40884 2.56681 1.38915 2.44719C1.36947 2.32757 1.385 2.2048 1.43385 2.09385C1.4827 1.98289 1.56277 1.88854 1.6643 1.82229C1.76582 1.75604 1.88443 1.72074 2.00566 1.7207V1.7207Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.71b5c1e66625cf6120f5e3cf2810c03f.svg";
export { ForwardRef as ReactComponent };